import { render, staticRenderFns } from "./status-a.vue?vue&type=template&id=0a7c3c55&"
import script from "./status-a.vue?vue&type=script&lang=js&"
export * from "./status-a.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports